// Custom JavaScript for L'AUBE BLANC
// Add custom scripts here. Do not modify theme.js directly.

/* CUSTOM:LB — チャネルトークのランチャーをモバイルドックに追従させる。
   背景：CSS だと ChannelTalk が当てるインラインstyle(transform) に負けて効かず、
   さらにランチャーは遅延生成されるため、JS で直接インラインに上書きする。
   挙動：
     ・ドック(.lb-dock)が表示中(.is-hidden でない)＆モバイル幅のときだけ、
       ランチャーをドック高さ(約3.75rem + セーフエリア)ぶん上へずらす。
     ・ドックが隠れたら元に戻す（ドックと同じ 0.25s ease で連動）。
   実装メモ：
     ・ランチャーは遅延生成 → 出現するまでポーリングで探す（open shadow DOM も探索）。
     ・ChannelTalk が style を上書きしても、style 監視で再適用する。
     ・既存 transform があれば壊さないよう、自分の translate を「合成」して付与する。
     ・ずらす対象は内側のアイコン(#ch-plugin-launcher)ではなく、ビューポートに固定
       されている親ラッパー（position:fixed の最外祖先）。内側だけ動かすと親の
       ヒット領域が元位置に残り、モバイルドックのハンバーガーを覆ってクリックを奪う。 */
(function () {
  var DOCK_SELECTOR = '.lb-dock';
  var LAUNCHER_SELECTORS = ['#ch-plugin-launcher', '.kIAbJl'];
  var SHIFT = 'translateY(calc(-3.75rem - env(safe-area-inset-bottom)))';
  var mobileMq = window.matchMedia('(max-width: 699px)');
  var launcher = null;
  var target = null; // 実際に transform を当てる要素（固定配置の親ラッパー）

  // ランチャーを light DOM → open shadow DOM の順で探す
  function findLauncher(root) {
    root = root || document;
    for (var i = 0; i < LAUNCHER_SELECTORS.length; i++) {
      var el = root.querySelector(LAUNCHER_SELECTORS[i]);
      if (el) return el;
    }
    var all = root.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      if (all[j].shadowRoot) {
        var found = findLauncher(all[j].shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  // ランチャーから上に辿り、ビューポートに固定されている最外祖先を返す。
  // これがヒット領域を持つラッパー。見つからなければランチャー自身を返す。
  function getShiftTarget(el) {
    var node = el;
    var fixed = el;
    while (node && node !== document.body && node.nodeType === 1) {
      if (getComputedStyle(node).position === 'fixed') fixed = node;
      node = node.parentElement;
    }
    return fixed;
  }

  function isDockVisible() {
    if (!mobileMq.matches) return false;
    var dock = document.querySelector(DOCK_SELECTOR);
    if (!dock || dock.classList.contains('is-hidden')) return false;
    return getComputedStyle(dock).display !== 'none';
  }

  // 自分の SHIFT を取り除いた「ChannelTalk 本来の transform」を返す
  function baseTransform() {
    var t = target.style.getPropertyValue('transform') || '';
    return t.replace(SHIFT, '').trim();
  }

  function applyShift() {
    if (!target || !target.isConnected) return;
    var current = target.style.getPropertyValue('transform') || '';
    var base = baseTransform();
    if (isDockVisible()) {
      var want = (base ? base + ' ' : '') + SHIFT;
      if (current !== want) {
        target.style.setProperty('transition', 'transform 0.25s ease', 'important');
        target.style.setProperty('transform', want, 'important');
      }
    } else if (current !== base) {
      if (base) {
        target.style.setProperty('transform', base, 'important');
      } else {
        target.style.removeProperty('transform');
      }
    }
  }

  function onLauncherFound() {
    // ヒット領域を持つ固定配置の親ラッパーを実ターゲットにする
    target = getShiftTarget(launcher);
    // ChannelTalk が style を書き換えても追従できるよう監視（ガードで無限ループ防止）
    new MutationObserver(applyShift).observe(target, {
      attributes: true,
      attributeFilter: ['style']
    });
    applyShift();
  }

  // ドックの表示状態(class)変化に追従
  var dock = document.querySelector(DOCK_SELECTOR);
  if (dock) {
    new MutationObserver(applyShift).observe(dock, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // 画面幅変更にも対応
  if (mobileMq.addEventListener) {
    mobileMq.addEventListener('change', applyShift);
  } else if (mobileMq.addListener) {
    mobileMq.addListener(applyShift);
  }

  // ランチャーは遅延生成されるので、見つかるまでポーリング（最大 ~20 秒）
  launcher = findLauncher();
  if (launcher) {
    onLauncherFound();
  } else {
    var tries = 0;
    var poll = setInterval(function () {
      launcher = findLauncher();
      if (launcher) {
        clearInterval(poll);
        onLauncherFound();
      } else if (++tries > 40) {
        clearInterval(poll);
      }
    }, 500);
  }
})();

/* CUSTOM:LB — 商品ページのカスタムタブ(custom_tab ブロック)をタブUIにまとめる。
   背景：main-product.liquid は custom_tab ブロックも他ブロックも縦積みで
   #product-extra-information 内に出力するだけ。Prestige はフラットなブロック構造で
   「タブの中にアコーディオンを入れる」といった入れ子ができない。そこで JS 側で
   「1つのタブ = そのパネル + 次のパネルが現れるまでの後続要素（アコーディオン等）」
   として吸収し、擬似的な入れ子を実現する。
   挙動：
     ・#product-extra-information の子要素を走査。.custom-product-tab-panel を起点に、
       次のパネル直前までの兄弟要素（アコーディオン等）を同じタブの中身として吸収する。
     ・最初のパネルより前の要素はタブに含めず、そのまま残す。
     ・運用：テーマエディターでブロックを「SNAP(custom_tab) → DETAIL(custom_tab) →
       素材/サイズ等のアコーディオン群」の順に並べると、SNAP タブが先頭・単独になり、
       DETAIL タブにアコーディオンが入る。
     ・並び順の例外：スナップが1件も無い商品では SNAP タブを最後尾に回す
       （data-custom-snaps-count="0" で判定）。空のタブが初期表示になるのを避け、
       DETAIL を先頭にするため。
     ・JS無効時は各要素が縦積みで表示される（プログレッシブエンハンスメント）。
     ・テーマエディター対応：セクション再読み込み(shopify:section:load)で再初期化し、
       ブロック選択(shopify:block:select)時は該当タブをアクティブにする。 */
(function () {
  var PANEL_SELECTOR = '.custom-product-tab-panel';
  var CONTAINER_SELECTOR = '#product-extra-information';

  // パネルを起点に、次のパネル直前までの兄弟要素を1タブぶんの中身として集める。
  // 返り値: [{ panel, nodes:[パネル, 吸収した後続要素...] }, ...]
  function collectTabSegments(container) {
    var segments = [];
    var current = null;
    var children = container.children;
    var i, el;

    for (i = 0; i < children.length; i++) {
      el = children[i];

      if (el.matches(PANEL_SELECTOR)) {
        current = { panel: el, nodes: [el] };
        segments.push(current);
      } else if (current) {
        current.nodes.push(el);
      }
      // current がまだ無い（最初のパネルより前）の要素はタブに含めない
    }

    return segments;
  }

  function activateTab(nav, panelsWrap, index) {
    var buttons = nav.children;
    var panels = panelsWrap.children;
    var i;

    for (i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-selected', i === index ? 'true' : 'false');
    }

    for (i = 0; i < panels.length; i++) {
      panels[i].hidden = i !== index;
    }
  }

  // スナップが1件も無いタブ（data-custom-snaps-count="0"）を最後尾へ回す。
  // それ以外の相対順序はそのまま保つ。テーマエディターの並びは
  // 「SNAP → DETAIL → アコーディオン群」を正とし、スナップが無い商品でだけ
  // DETAIL が先頭に来るようにするための例外処理。
  function moveEmptySnapTabsLast(segments) {
    var kept = [];
    var moved = [];
    var i, snaps;

    for (i = 0; i < segments.length; i++) {
      snaps = segments[i].panel.querySelector('[data-custom-snaps-count]');

      if (snaps && snaps.getAttribute('data-custom-snaps-count') === '0') {
        moved.push(segments[i]);
      } else {
        kept.push(segments[i]);
      }
    }

    return kept.concat(moved);
  }

  function buildTabs(segments) {
    var wrapper, nav, panelsWrap, anchor, i, j, seg, tabId, panelId, button, tabpanel;

    if (!segments.length) {
      return;
    }

    if (segments[0].panel.closest('.custom-product-tabs')) {
      return; // 既にタブ化済み（再初期化時）
    }

    // タブUIを挿入する位置は DOM 上の先頭パネルの場所。並べ替えると segments[0] が
    // DOM 先頭とは限らなくなるため、並べ替える前に控えておく。
    anchor = segments[0].panel;
    segments = moveEmptySnapTabsLast(segments);

    wrapper = document.createElement('div');
    wrapper.className = 'custom-product-tabs';

    nav = document.createElement('div');
    nav.className = 'custom-product-tabs__nav';
    nav.setAttribute('role', 'tablist');

    panelsWrap = document.createElement('div');
    panelsWrap.className = 'custom-product-tabs__panels';

    // DOM上の先頭パネルがあった位置にタブUIを挿入
    anchor.parentNode.insertBefore(wrapper, anchor);
    wrapper.appendChild(nav);
    wrapper.appendChild(panelsWrap);

    for (i = 0; i < segments.length; i++) {
      seg = segments[i];
      tabId = 'custom-product-tab-' + i + '-' + Math.random().toString(36).slice(2, 8);
      panelId = tabId + '-panel';

      button = document.createElement('button');
      button.type = 'button';
      button.className = 'custom-product-tabs__tab h6';
      button.setAttribute('role', 'tab');
      button.setAttribute('id', tabId);
      button.setAttribute('aria-controls', panelId);
      button.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      button.textContent = seg.panel.getAttribute('data-custom-tab-title') || '';

      // タブ1つぶんの中身（パネル＋吸収した後続要素）を1つのラッパーにまとめる
      tabpanel = document.createElement('div');
      tabpanel.className = 'custom-product-tabs__panel';
      tabpanel.setAttribute('role', 'tabpanel');
      tabpanel.setAttribute('id', panelId);
      tabpanel.setAttribute('aria-labelledby', tabId);
      tabpanel.hidden = i !== 0;

      for (j = 0; j < seg.nodes.length; j++) {
        tabpanel.appendChild(seg.nodes[j]);
      }

      (function (index) {
        button.addEventListener('click', function () {
          activateTab(nav, panelsWrap, index);
        });
      })(i);

      nav.appendChild(button);
      panelsWrap.appendChild(tabpanel);
    }
  }

  function initProductTabs(root) {
    var containers = (root || document).querySelectorAll(CONTAINER_SELECTOR);
    var c;

    for (c = 0; c < containers.length; c++) {
      buildTabs(collectTabSegments(containers[c]));
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductTabs();
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initProductTabs(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      // 選択したブロック（パネル本体でも、吸収されたアコーディオン等でも）が属するタブを開く
      var tabpanel = event.target.closest && event.target.closest('.custom-product-tabs__panel');
      var tabsWrapper, panelsWrap, nav, index;

      if (!tabpanel) {
        return;
      }

      tabsWrapper = tabpanel.closest('.custom-product-tabs');

      if (!tabsWrapper) {
        return;
      }

      panelsWrap = tabsWrapper.querySelector('.custom-product-tabs__panels');
      nav = tabsWrapper.querySelector('.custom-product-tabs__nav');
      index = Array.prototype.indexOf.call(panelsWrap.children, tabpanel);

      if (index > -1) {
        activateTab(nav, panelsWrap, index);
      }
    });
  }
})();
